import { dichVuThongTinApi } from "../../../api/dich-vu/dichVuThongTinApi";
import { IDichVuThongTin } from "../../../model/respone/dich-vu/IDichVuThongTin";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDichVuThongTinActionIds,
  IDichVuThongTinActionTypes,
} from "../../action-types/dich-vu/IDichVuThongTinActions";
import { rootActions } from "../../actions/rootActions";

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

export function* dichVuThongTinSaga(): any {
  yield takeLatest(eDichVuThongTinActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDichVuThongTinActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDichVuThongTinActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(dichVuThongTinApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.dichVu.thongTin.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.dichVu.thongTin.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDichVuThongTinActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDichVuThongTin;
  if (payload.id > 0) {
    res = yield call(dichVuThongTinApi.Update, payload);
  } else {
    res = yield call(dichVuThongTinApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.dichVu.thongTin.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.dichVu.thongTin.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IDichVuThongTinActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuThongTinApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.thongTin.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.dichVu.thongTin.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
